export const classificationInnerRoutePaths = {
  storiesList: 'listagem-inscricoes',
  storyResume: 'resumo-inscricao',
} as const;

export const classificationRoutePaths = {
  home: '/classificacao',
  storiesList: `/classificacao/${classificationInnerRoutePaths.storiesList}`,
  storyResume: `/classificacao/${classificationInnerRoutePaths.storyResume}/:id`,
} as const;

export function classificationStoryResumePath(id: number): string {
  return classificationRoutePaths.storyResume.replace(':id', id + '');
}
